// @flow
import React from "react"
import { InputField, Label, FormGroup, Error } from "../UI/Form"
import { PrimaryButton } from "../UI/Buttons"
import { Field, reduxForm } from "redux-form"
import { validate } from "./validations"

type ForgotFormProps = {
  handleSubmit: Function,
  error: string
}

const ForgotForm = ({ handleSubmit, error }: ForgotFormProps) =>
  <form onSubmit={handleSubmit}>
    <FormGroup>
      <Label htmlFor="email">Email Address</Label>
      <Field name="email" component={InputField} type="text" />
    </FormGroup>
    {error
      ? <Error>
          {error}
        </Error>
      : ""}
    <PrimaryButton block={true}>Send Magic Link</PrimaryButton>
  </form>

export default reduxForm({
  form: "forgot",
  validate: validate({ includePassword: false })
})(ForgotForm)



// WEBPACK FOOTER //
// ./src/PublicArea/ForgotForm.js